import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ListComponent} from './components/list.component';
import {SearchComponent} from './components/search/search.component';
import {ResultComponent} from './components/result/result.component';
import {RouterModule} from '@angular/router';
import { FilterBoxComponent } from './components/search/filter-box/filter-box.component';
import {FormModule} from '../../form/form.module';
import {ToolsModule} from '../../tools/tools.module';
import {AppComponentsModule} from '../../app-components/app-components.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { PopularComponent } from './components/search/popular/popular.component';
import { RecommendedComponent } from './components/search/recommended/recommended.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path: ':dealer_code/szukaj', pathMatch: 'full', component: ListComponent},
      {path: ':dealer_code', pathMatch: 'full', component: ListComponent},
      {path: '', component: ListComponent},
    ]),
    FormModule,
    ToolsModule,
    AppComponentsModule,
    NgbModule,
  ],
  declarations: [
    ListComponent,
    ResultComponent,
    SearchComponent,
    FilterBoxComponent,
    PopularComponent,
    RecommendedComponent
  ]
})
export class ListModule { }
